import * as React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';
import { connect } from 'react-redux'; // Connecting to Redux
import { Dispatch } from 'redux';
import { ReduxStoreModel } from "src/redux/ReduxModel";
import UserAction, { EmulateUserType } from 'src/redux/UserActions';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset,
    DataTableButtonExport
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ClientDTO from 'src/models/client/ClientDTO';
import ClientApiController from 'src/api/ClientApiController';
import AccountApiController from 'src/api/AccountApiController';
import Button from 'antd/lib/button/button';
import { Tooltip, message } from 'antd';

interface ClientsProps extends PageProps<{}>, LocalizeContextProps {
    emulateUser: (id: number, type: EmulateUserType) => Promise<boolean>;
}

interface ClientsState {
    loading: boolean;
    tableRecords: ClientDTO[];
    formRedirect: boolean;
}

class Clients extends React.Component<ClientsProps, ClientsState> {
    constructor(props: ClientsProps) {
        super(props);
        bindAllOfThis(this, Clients.prototype);

        this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
    }

    private emulateClient(stateId: number, districtId: number, schoolId: number) {
        let id: number;
        let userType: EmulateUserType;
        if (stateId != null) {
            id = stateId;
            userType = "state";
        } else if (districtId != null) {
            id = districtId;
            userType = "district";
        } else {
            id = schoolId;
            userType = "school";
        }

        // Fire emulation request, which will take some time, and direct user to emulation loading page
        this.props.emulateUser(id, userType).then(result => {
            if (!result) {
                message.error(this.props.translate("admin.common.messageEmulateError"));
                return;
            }
        });
        this.props.history.push(Routes.ADMIN_EMULATE_USER); // Show them a fancy page while we mess with their emulation info
    }

    private editClient(clientId: number) {
        this.props.history.push(Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLIENT, clientId));
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<ClientDTO>) => void): void {
        this.setState({ loading: true });

        ClientApiController.getClientTableData(requestState)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<ClientDTO>[] {
        let editLink = (text, record: ClientDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLIENT, record.clientId);

        return [
            DataTable.StandardColumns.Text("admin.clients.columnHeader1", 'clientName'),
            // DataTable.StandardColumns.Text("admin.clients.columnHeader2", 'clientTypeName'),
            DataTable.AdvancedColumns.Enum(<Translate id="admin.clients.columnHeader2" />, "clientTypeName", ["State", "District", "School"]),
            DataTable.StandardColumns.Text("admin.clients.columnHeader3", 'locationName'),
            {
                columnProps: {
                    key: 'emulate',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={<Translate id="admin.common.emulateColumnHeader" />} arrowPointAtCenter>
                                <Button shape="circle" icon="user" title="view" onClick={() => this.emulateClient(record.stateId, record.districtId, record.schoolId)} />
                            </Tooltip>
                        );
                    }
                }
            },
            {
                columnProps: {
                    key: 'edit',
                    align: 'center',
                    width: 35,
                    render: (text, record: ClientDTO) => {
                        return (
                            <Tooltip placement="bottom" title={<Translate id="admin.common.editColumnHeader" />} arrowPointAtCenter>
                                <Button shape="circle" icon="edit" title="edit" onClick={() => this.editClient(record.clientId)} />
                            </Tooltip>
                        );
                    }
                }
            },
        ];
    }

    render() {
        if (this.state.formRedirect) {
            return <Redirect to={Routes.ADMIN_ADD_EDIT_CLIENT} push />;
        }

        return (
            <div>
                <h2><Translate id="admin.clients.tableHeader" /></h2>

                <DataTable
                    serverSide={true}
                    tableProps={{ rowKey: 'clientId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton("admin.clients.addButton", () => { this.setState({ formRedirect: true }); }),
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return ({
        emulateUser: (id: number, type: EmulateUserType) => UserAction.EmulateUser(dispatch, type, id),
    });
}

export default connect(null, mapDispatchToProps)(withLocalize(Clients));



// WEBPACK FOOTER //
// ./src/pages/admin/Clients.tsx